import PropTypes from 'prop-types'
import React from 'react'
import cn from 'classnames'

import { ThreeDTour, VideoTour } from '../../Svg'
import { default as poolUrl } from 'images/modules/Hdp/Highlights/i-pool.svg'
import { default as tennisUrl } from 'images/modules/Hdp/Highlights/i-tennis.svg'
import { default as spaUrl } from 'images/modules/Hdp/Highlights/i-spa.svg'
import { default as waterfrontUrl } from 'images/modules/Hdp/Highlights/i-waterfront.svg'
import { default as parkingUrl } from 'images/modules/Hdp/Highlights/i-parking.svg'
import { default as locationUrl } from 'images/modules/Hdp/Highlights/i-location.svg'
import { default as defaultUrl } from 'images/modules/Hdp/Highlights/i-default.svg'
import { default as openHouseUrl } from 'images/modules/Shared/i-open-house.svg'


const getCapitalized = text => text.charAt(0) + text.slice(1).toLowerCase()

const ImageOverlay = ({
  containsZillow3dTour,
  containsVideoTour,
  closestOpenHouseDate,
  closestOpenHouseTime,
  isRecent,
  isActive,
  status,
  highlights
}) => {
  const isOpenHouseExist = closestOpenHouseDate && closestOpenHouseTime

  const iconMap = {
    'highlights-pool': poolUrl,
    'highlights-tennis': tennisUrl,
    'highlights-spa': spaUrl,
    'highlights-waterfront': waterfrontUrl,
    'highlights-parking': parkingUrl,
    'highlights-location': locationUrl
  }

  return (
    <div className='CardDesktop-imgOverlay'>
      <div className='CardDesktop-topFeatures'>
        {isRecent && (
          <div className='CardDesktop-newBadge'>
            <span className='CardDesktop-newBadge--text'>New</span>
          </div>
        )}
        {isOpenHouseExist && (
          <div className='CardDesktop-keyAmenity CardDesktop-keyAmenity--openHouse'>
            <img src={openHouseUrl} className='CardDesktop-openHouseIcon' alt='i' />
            <p className='CardDesktop-openHouse'>
              <span className='CardDesktop-date'>{closestOpenHouseDate}</span>
              <span className='CardDesktop-time'>{closestOpenHouseTime}</span>
            </p>
          </div>
        )}
        {!isOpenHouseExist && (highlights.map(highlight => (
          <div className='CardDesktop-keyAmenity'>
            <img src={iconMap[highlight.key] || defaultUrl} className='CardDesktop-amenityIcon' alt='icon' />
            <span className='CardDesktop-label'>{getCapitalized(highlight.description)}</span>
          </div>
        )))}
      </div>
      <div className='CardDesktop-bottomFeatures'>
        <div className='CardDesktop-statusInfo'>
          <div className={cn('CardDesktop-indicator', { 'CardDesktop-indicator--inactive': !isActive })} />
          <p className='CardDesktop-statusLabel'>{status}</p>
        </div>
        <div className='CardDesktop-tours'>
          {containsVideoTour && (
            <VideoTour className='CardDesktop-icon' />
          )}
          {containsZillow3dTour && (
            <ThreeDTour className='CardDesktop-icon' />
          )}
        </div>
      </div>
    </div>
  )
}

ImageOverlay.propTypes = {
  containsZillow3dTour: PropTypes.bool,
  containsVideoTour: PropTypes.bool,
  closestOpenHouseDate: PropTypes.string,
  closestOpenHouseTime: PropTypes.string,
  isRecent: PropTypes.bool,
  isActive: PropTypes.bool,
  status: PropTypes.string,
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired
    })
  )
}

export default ImageOverlay
